import React, { memo } from "react";

import { Container, Title } from "./styles";

import Question from "components/Question";

function Questionnaire({ sections, register, errors, readOnly }) {
  return (
    <Container>
      {sections.map((section, sectionIndex) => {
        const prefix = `sections[${sectionIndex}]`;

        const sectionErrors =
          errors && errors["sections"] && errors["sections"][sectionIndex];
        const questionsErrors = sectionErrors && sectionErrors["questions"];

        return (
          <section key={section.id}>
            {sections.length > 1 && (
              <Title>
                <strong>{section.order} -</strong> {section.title}
              </Title>
            )}

            {section.questions.map((question, questionIndex) => {
              const questionError =
                questionsErrors && questionsErrors[questionIndex];

              return (
                <Question
                  prefix={prefix}
                  key={question.id}
                  question={question}
                  register={register}
                  index={questionIndex}
                  error={questionError}
                  readOnly={readOnly}
                />
              );
            })}
          </section>
        );
      })}
    </Container>
  );
}

export default memo(Questionnaire);
